/*
 * @Description: 导出、下载
 * @Author: PF
 * @Date: 2022-10-09 11:15:20
 * @LastEditors: PF
 * @LastEditTime: 2026-09-07 16:43:05
 * @FilePath: \ZHXY_VUE3.0\src\utils\requestDownload.js
 */
import axios from 'axios'
import qs from 'qs'
import { warningPrompt, errorPrompt } from '@/utils/promptInfo'
import { ElLoading } from 'element-plus'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000
})

// request interceptor
service.interceptors.request.use(
  config => {
    if ($cookies.get(process.env.VUE_APP_BASE_TOKEN)) {
      config.headers.Authorization = $cookies.get(process.env.VUE_APP_BASE_TOKEN)
    }
    if (!(config.data instanceof FormData) && typeof config.data === 'object') {
      config.data = qs.stringify(config.data)
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

const exportExcel = async (url, params = {}) => {
  console.log('导出地址', url)
  console.log('导出参数', params)
  // const loading = ElLoading.service({
  //   lock: true,
  //   text: 'Loading',
  //   background: 'rgba(0, 0, 0, 0.7)'
  // })
  // axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8'
  // axios({
  //   method: 'post',
  //   url: process.env.VUE_APP_BASE_API + url,
  //   headers: { 'Content-Type': 'application/json', accesscode: $cookies.get(process.env.VUE_APP_BASE_TOKEN) },
  //   data: params,
  //   responseType: 'arraybuffer'
  // }).then(res => {
  //   // 这里的type最好参考Response Headers里面的content-type，有可能是application/vnd.ms-excel
  //   const blob = new Blob([res.data], {
  //     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  //   })
  //   // 获取文件名，根据自己需要的分割
  //   if (res.headers['content-disposition']) {
  //     const fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
  //     const a = document.createElement('a')
  //     const url = window.URL.createObjectURL(blob)
  //     a.href = url
  //     a.download = decodeURI(fileName)
  //     document.body.appendChild(a)
  //     a.style.display = 'none'
  //     a.click()
  //     document.body.removeChild(a)
  //     window.URL.revokeObjectURL(url)
  //   } else {
  //     console.log('下载文件请求错误', res)
  //     warningPrompt('下载文件请求错误')
  //   }
  //   loading.close()
  // }, error => {
  //   loading.close()
  //   console.log(error)
  // })

  try {
    const res = await axios.post(process.env.VUE_APP_BASE_API + url, params, {
      headers: { 'Content-Type': 'application/json', accesscode: $cookies.get(process.env.VUE_APP_BASE_TOKEN) },
      responseType: 'arraybuffer'
    })

    // ⚠️ 边界：状态码 200 但后端其实返回的是 JSON（业务校验不通过）
    const contentType = res.headers?.['content-type'] ?? ''
    if (contentType.includes('application/json')) {
      const text = new TextDecoder('utf-8').decode(res.data)
      const json = JSON.parse(text)
      warningPrompt(json.msg ?? json.message ?? '导出失败')
      return
    }

    // 正常文件流：创建 Blob 下载
    const blob = new Blob([res.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    const fileName = parseFileName(res.headers?.['content-disposition']) || '导出文件.xlsx'

    const href = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = href
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(href)
    // loading.close()
  } catch (err) {
    console.log(err)
    // loading.close()
    errorPrompt('导出失败', err)
  }
}
/** 解析 content-disposition，兼容 filename*=UTF-8''  */
function parseFileName (disposition) {
  if (!disposition) return null
  const star = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(disposition)
  if (star) return decodeURIComponent(star[1])
  const plain = /filename\s*=\s*"?([^";]+)"?/i.exec(disposition)
  if (plain) {
    try {
      return decodeURIComponent(plain[1])
    } catch {
      return plain[1]
    }
  }
  return null
}

export default {
  service,
  exportExcel
}
// 下载 开始
export function download (path, fileName) {
  fetch(path).then(res =>
    res.blob()
  ).then((blob) => {
    const objectUrl = URL.createObjectURL(blob) // 创建 url 对象
    aTagDownload(objectUrl, fileName) // 调用 上面 [2] 动态方式
  }).catch((err) => {
    errorPrompt('Request Failed', err)
  })
}
export function aTagDownload (url, filename) {
  const a = document.createElement('a') // 创建 a 标签
  a.href = url // 下载路径
  a.download = filename // 下载属性，文件名
  a.style.display = 'none' // 不可见
  document.body.appendChild(a) // 挂载
  a.click() // 触发点击事件
  document.body.removeChild(a) // 移除
}
// 根据Url下载文件非浏览器直接打开
export function downloadImage (url, title) {
  const link = document.createElement('a')
  // 这里是将url转成blob地址
  fetch(url).then(res => res.blob()).then(blob => {
    link.href = URL.createObjectURL(blob)
    link.style.display = 'none'
    link.download = title
    link.click()
  })
}
// 下载 结束

// 带进度 上传 开始
export function importClick (url, formData, whiteList = [], callback) {
  // 检测违规格式 开始
  if (whiteList) {
    const fileSuffix = file.file.name.substring(file.file.name.lastIndexOf('.') + 1)
    // const whiteList = ['exe', 'com', 'bat', 'scr']
    const isSuffix = whiteList.includes(fileSuffix.toLowerCase())
    if (isSuffix) {
      return warningPrompt('禁止上传 ' + whiteList + ' 格式文件')
    }
  }
  // // 检测违规格式 结束
  axios({
    url: process.env.VUE_APP_BASE_API + url,
    data: formData,
    method: 'post',
    headers: { 'Content-Type': 'application/json', accesscode: $cookies.get(process.env.VUE_APP_BASE_TOKEN) },
    // 上传进度
    onUploadProgress: {
      onUploadProgress: progressEvent => {
        if (progressEvent.lengthComputable) {
          // 是否存在进度
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          const info1 = {
            isProgress: true,
            percentage: percentCompleted
          }
          callback(info1)
          if (percentCompleted === 100) {
            const info2 = {
              isProgress: false
            }
            callback(info2)
          }
        }
      }
    }
  }).then(res => {
    return res.data
  })
}
// 带进度 上传 结束

/**
 * 通用文件流下载
 * @param {Blob} blob - 文件流
 * @param {string} fileName - 文件名
 */
export function exportWordDoc (url, params) {
  return axios({
    url: process.env.VUE_APP_BASE_API + url, // 你的接口地址
    method: 'POST',
    data: params,
    headers: { 'Content-Type': 'application/json', accesscode: $cookies.get(process.env.VUE_APP_BASE_TOKEN) },
    responseType: 'blob' // ⚠️ 关键！必须是 blob
  })
}
